import linkIcon from '@/assets/images/chatbot/link_icon.png'
import thumbsUpImage from '@/assets/images/chatbot/thumbsup.svg'
import thumbsDownImage from '@/assets/images/chatbot/thumbsdown.svg'
import i18n from 'services/i18n'
import { Converter } from 'showdown'

export function getFeedBackTemplate (response) {
    return `
        <div class="feedback-container-history" id="feedback-container_${response.id}">
        <span class="feedback-text">${getFeedBackText()}</span>
            ${response.feedback.type ? (`
                <img id="${response.feedback.type}_${response.id}" class="feedback-icon-sent-history" src="${response.feedback.type === 'positive' ? thumbsUpImage : thumbsDownImage}" />
        `) : (`
            <img class="feedback-icon positive" id="positive_${response.id}" src=${thumbsUpImage} />
            <img class="feedback-icon negative" id="negative_${response.id}" src=${thumbsDownImage} />
            `)}
        </div>`
}

export function getRecommendedMessageLink (response) {
    let coursesTemplate = ``
    if (response.relatedContent.relatedCourses.length > 0 || response.relatedContent.relatedLearningPaths.length > 0) {
        coursesTemplate += `<br><br><div class="course-links-container">`
    }
    if (response.relatedContent.relatedCourses.length > 0) {
        response.relatedContent.relatedCourses.forEach(course => {
            coursesTemplate += `
                <div class="course-link" id="${course.courseId}">
                    <img id="${course.courseId}" class="course-link-icon" src="${linkIcon}" />
                    <span class="course-link-text" id="${course.courseId}">${course.title}</span>
                </div>
                `
        })
    }
    if (response.relatedContent.relatedLearningPaths.length > 0) {
        response.relatedContent.relatedLearningPaths.forEach(learningPath => {
            coursesTemplate += `
                <div class="learningpath-link" id="${learningPath.courseId}">
                    <img id="${learningPath.learningPathId}" class="course-link-icon" src="${linkIcon}" />
                    <span class="course-link-text" id="${learningPath.learningPathId}">${learningPath.name}</span>
                </div>
                `
        })
    }
    if (response.relatedContent.relatedCourses.length > 0 || response.relatedContent.relatedLearningPaths.length > 0) {
        coursesTemplate += `</div>`
    }
    return coursesTemplate
}

export function getFeedBackText () {
    return i18n.t('Chatbot.feedback_text')
}

export function textFormatter (text) {
    const converter = new Converter({
        noHeaderId: true,
        simpleLineBreaks: true,
        strikethrough: true,
        tasklists: true
    })

    text = converter.makeHtml(text)
    return text
}
